import diagnosticFeature01 from "../img/diagnostic01.svg";
import diagnosticFeature02 from "../img/diagnostic02.svg";
import diagnosticFeature03 from "../img/diagnostic03.svg";
import diagnosticFeature04 from "../img/diagnostic04.svg";
import diagnosticFeature05 from "../img/diagnostic05.svg";
import diagnosticFeature06 from "../img/diagnostic06.svg";

import feature1 from "../img/feature1.svg";
import feature2 from "../img/feature2.svg";
import feature3 from "../img/feature3.svg";
import feature4 from "../img/feature4.svg";
import feature5 from "../img/feature5.svg";
import feature6 from "../img/feature6.svg";

import video01 from "../img/video01.mp4";
import video02 from "../img/video02.mp4";
import video03 from "../img/video03.mp4";
import video04 from "../img/video04.mp4";
import video05 from "../img/video05.mp4";
import video06 from "../img/video06.mp4";
import video07 from "../img/video07.mp4";
import video08 from "../img/video08.mp4";
import video01Placeholder from "../img/video01.jpg";
import video02Placeholder from "../img/video02.jpg";
import video03Placeholder from "../img/video03.jpg";
import video04Placeholder from "../img/video04.jpg";
import video05Placeholder from "../img/video05.jpg";

export const diagnosticFeatures = [
  {
    title: "Batterie",
    image: diagnosticFeature01,
  },
  {
    title: "Laden",
    image: diagnosticFeature04,
  },
  {
    title: "Cloud Control",
    image: diagnosticFeature02,
  },

  {
    title: "Display",
    image: diagnosticFeature05,
  },
  {
    title: "Pods",
    image: diagnosticFeature03,
  },
  {
    title: "Sonstiges",
    image: diagnosticFeature06,
  },
];

export const features = [
  {
    image: feature1,
    title: "Verbesserter Nutzungstracker",
    content:
      "Behalte die Anzahl deiner Züge im Blick und erhalte weitere detaillierte Einblicke",
  },
  {
    image: feature2,
    title: "Cloud Control",
    content: "Passe die Intensität deines Lieblings-Flavours individuell an",
  },
  {
    image: feature3,
    title: "Find My Vape",
    content: "Finde dein Gerät jederzeit wieder",
  },
  {
    image: feature4,
    title: "Ultra Pod Tracker",
    content: "Erhalte Einblicke in deine Flavour-Nutzung",
  },
  {
    image: feature5,
    title: "Auflade-Erinnerungen",
    content: "Werde benachrichtigt, wenn der Akkuschwach wird",
  },
  {
    image: feature6,
    title: "Nutzungshinweise",
    content:
      "Tageslimit festlegen und Benachrichtigung erhalten, sobald es erreicht ist",
  },
];

export const videoCards = [
  {
    ident: "ultra_video_1",
    title: "App herunterladen - Android",
    image: video01Placeholder,
    videoTime: 10,
    video: video01,
    time: "0:25",
  },
  {
    ident: "ultra_video_2",
    title: "Bluetooth-Kopplung - Android",
    image: video02Placeholder,
    videoTime: 10,
    video: video02,
    time: "0:57",
  },
  {
    ident: "ultra_video_3",
    title: "App herunterladen - iOS",
    image: video03Placeholder,
    videoTime: 10,
    video: video03,
    time: "0:34",
  },
  {
    ident: "ultra_video_4",
    title: "Bluetooth-Kopplung - iOS",
    image: video04Placeholder,
    videoTime: 10,
    video: video04,
    time: "1:08",
  },
  {
    ident: "ultra_video_5",
    title: "Hauptfunktionen",
    image: video05Placeholder,
    videoTime: 10,
    video: video05,
    time: "0:30",
  },
  {
    ident: "ultra_video_6",
    title: "Gerätenavigation",
    image: video05Placeholder,
    videoTime: 10,
    video: video06,
    time: "0:25",
  },
  {
    ident: "ultra_video_7",
    title: "Batterie und Aufladen",
    image: video05Placeholder,
    videoTime: 10,
    video: video07,
    time: "0:25",
  },
  {
    ident: "ultra_video_8",
    title: "Gerätesperre und -entsperrung",
    image: video05Placeholder,
    videoTime: 10,
    video: video08,
    time: "0:19",
  },
];
